import { CommonButton } from "@components/CommonButton";
import { Trans } from "react-i18next";

export interface ModalFooterProps {
  disabledCancel?: boolean;
  disabledPost?: boolean;
  onCancel: () => void;
  onPost?: () => void;
  publishing?: boolean;
}

export const ModalFooter = (props: ModalFooterProps) => {
  const { disabledCancel, disabledPost, onCancel, onPost, publishing } = props;
  return (
    <div className="flex items-center justify-end gap-[8px] border-t border-kds-border px-[16px] py-[12px]">
      <CommonButton type="default" size="large" disabled={disabledCancel} onClick={onCancel}>
        <Trans>Cancel</Trans>
      </CommonButton>
      <CommonButton type="primary" size="large" disabled={disabledPost} onClick={onPost} loading={publishing}>
        <Trans>Post</Trans>
      </CommonButton>
    </div>
  );
};
